export const timePanel = {
    0: "departureTime",
    1: "arrivalTime",
    2: "completionTime"
};
export const get24hrFormatTime = (time, amPm) => {
    if (!time || !time.includes(":")) {
        return "00:00"; // fallback for invalid time
    }
    const timeParts = time.split(":");
    const hours = parseInt(timeParts[0], 10);
    const minutes = parseInt(timeParts[1], 10);
    if (isNaN(hours) || isNaN(minutes)) {
        return "00:00"; // fallback for invalid numbers
    }
    let adjustedHours = hours;
    if (amPm === "PM" && hours < 12) {
        adjustedHours += 12;
    }
    if (amPm === "AM" && hours === 12) {
        adjustedHours = 0;
    }
    return `${adjustedHours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
};
export const prepareFutureChargeOptionsRequestBody = (assetId, projectId, time, timeUnits, timePanelActiveIndex) => {
    if (time) {
        const selectedTime = get24hrFormatTime(time, timeUnits);
        const today = new Date();
        const day = today.getDate().toString().padStart(2, "0");
        const month = (today.getMonth() + 1).toString().padStart(2, "0");
        const year = today.getFullYear();
        const todayFormatted = `${year}-${month}-${day}`;
        const timestamp = todayFormatted + "T" + selectedTime;
        return {
            assets: assetId,
            projectId: projectId,
            [timePanel[timePanelActiveIndex]]: timestamp
        };
    }
};
